var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"waves-effect waves-light btn btn-icon secondary-content--hidden",class:{ active: _vm.active },on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', !_vm.active)}}},[_c('feather',{attrs:{"type":"trash-2","size":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }